import { useSnackbar } from 'notistack'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { STORAGE_KEYS } from 'src/constants'
import AuthDataService from 'src/services/auth.service'

export const useTokenJourneyRedirect = () => {
  const { token } = useParams()
  const accessToken = localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN)
  const refreshToken = localStorage.getItem(STORAGE_KEYS.REFRESH_TOKEN)
  const { enqueueSnackbar } = useSnackbar()
  const [isLoading, setIsLoading] = useState(false)

  let journeyRedirect = ''

  if (token) {
    const decode = atob(token.split('.')[1])
    const data = JSON.parse(decode)
    if (data?.journeyRedirect) {
    }
    journeyRedirect = data.journeyRedirect
  }

  useEffect(() => {
    const journeyRedirect = async () => {
      if (!token || !accessToken || !refreshToken) return

      setIsLoading(true)
      try {
        const accessTokenStatus = await AuthDataService.validateToken(accessToken)
        const refreshTokenStatus = await AuthDataService.validateToken(refreshToken)

        if (
          accessTokenStatus &&
          refreshTokenStatus &&
          accessTokenStatus.status &&
          refreshTokenStatus.status
        ) {
          const decode = atob(token.split('.')[1])
          const data = JSON.parse(decode)

          if ('journeyRedirect' in data) {
            enqueueSnackbar('You have successfully authenticated', { variant: 'success' })

            setTimeout(() => {
              setIsLoading(false)
            }, 2500)

            setTimeout(() => {
              window.location.replace(
                data.journeyRedirect + `?accessToken=${accessToken}&refreshToken=${refreshToken}`,
              )
            }, 1000)
          }
        } else {
          setIsLoading(false)
        }
      } catch {
        setIsLoading(false)
      }
    }

    journeyRedirect()
  }, [token, accessToken, refreshToken, enqueueSnackbar])

  return { isJourneyTokenAuthLoading: isLoading, journeyRedirect }
}
